import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatToolbar } from '@angular/material/toolbar';
import { MatFormField } from '@angular/material/form-field';

export interface Fruit {
  name: string;
}

export interface Food {
  value: string;
  viewValue: string;
}
@Component({
  selector: 'app-manager-add-site-group',
  templateUrl: './manager-add-site-group.component.html',
  styleUrls: ['./manager-add-site-group.component.scss'],
  standalone:true,
  imports: [CommonModule,MatToolbar,MatFormField]
})
export class ManagerAddSiteGroupComponent implements OnInit {
  options: FormGroup;
  foods: Food[] = [
    { value: 'steak-0', viewValue: '1' },
    { value: 'pizza-1', viewValue: '2' },
    { value: 'tacos-2', viewValue: '3' }
  ];

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  fruits: Fruit[] = [
    { name: 'Tech' },
    { name: 'Computer' },
    { name: 'Awsome' },
  ];



  breadcrumbsArray: any = [
    "manager-client-list",
    "manager-users-site-group",
    "manager-site-group",
  ];

  pageRef: any;
  showUpdateBtn: boolean;
  showEditUsertxt: string;
  showViewLicense: boolean;
  showSavebtn: boolean;
  pid: any;
  constructor(fb: FormBuilder, public router: Router, private activeRoute: ActivatedRoute) {
    activeRoute.queryParams.subscribe(params => {
      this.pageRef = params['pageRef'];
      if (this.pageRef === 'edit-site') {
        this.showUpdateBtn = true;
        this.showEditUsertxt = "Edit Site & Groups";
        this.showViewLicense = true;
        this.showSavebtn = false;
      } else {
        this.showUpdateBtn = false;
        this.showSavebtn = true;
        this.showEditUsertxt = "Site & Groups";
        this.showViewLicense = false;
      }
    });




    this.options = fb.group({
      hideRequired: false,
      floatLabel: 'auto',
    });
  }

  goToPageLink(name: string) {
    this.router.navigate([name]);
  }

  ngOnInit() { }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;
    // Add our fruit
    if ((value || '').trim()) {
      this.fruits.push({ name: value.trim() });
    }
    // Reset the input value
    if (input) {
      input.value = '';
    }
  }

  remove(fruit: Fruit): void {
    const index = this.fruits.indexOf(fruit);

    if (index >= 0) {
      this.fruits.splice(index, 1);
    }
  }

  addDevice() {
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        clientName: this.pid
      }
    };
    this.router.navigate(['manager-site-group'], navigationExtras);
  }

  saveDevice() {
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        pid: true
      }
    };
    this.router.navigate(['manager-users-site-group'], navigationExtras);
  }

  saveAndAddGroup() {
    this.router.navigate(["manager-add-group"]);
  }
}
